import React from "react";
import { puzzleAnswers } from "../../lib/time-utils";
import { STORAGE_KEYS } from "../../lib/constants";
import { fetchPuzzleData } from "../../lib/firebase";

export const PuzzleDataContext = React.createContext();

function PuzzleDataProvider({ children }) {
  const [gameData, setGameData] = React.useState(puzzleAnswers);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [isLocked, setIsLocked] = React.useState(false);

  React.useEffect(() => {
    const loadPuzzle = async () => {
      try {
        setIsLoading(true);

        // Try to fetch from Firebase
        const firebaseData = await fetchPuzzleData();

        if (firebaseData) {
          setGameData(firebaseData.puzzle);
          setIsLocked(firebaseData.isLocked ?? false);
        } else {
          // Fall back to localStorage admin puzzle
          try {
            const adminPuzzle = localStorage.getItem(STORAGE_KEYS.adminPuzzle);
            if (adminPuzzle) {
              const parsed = JSON.parse(adminPuzzle);
              // Validate the puzzle structure
              if (
                Array.isArray(parsed) &&
                parsed.length === 4 &&
                parsed.every(
                  cat =>
                    cat.category &&
                    Array.isArray(cat.words) &&
                    cat.words.length === 4 &&
                    cat.difficulty
                )
              ) {
                setGameData(parsed);
              } else {
                // Use default puzzle
                setGameData(puzzleAnswers);
              }
            } else {
              // Use default puzzle
              setGameData(puzzleAnswers);
            }
          } catch (e) {
            console.error("Error loading admin puzzle:", e);
            setGameData(puzzleAnswers);
          }
        }
      } catch (error) {
        console.error("Failed to load puzzle:", error);
        setError(error);
        // Fall back to default puzzle
        setGameData(puzzleAnswers);
      } finally {
        setIsLoading(false);
      }
    };

    loadPuzzle();
  }, []);

  const categorySize = gameData[0].words.length;
  const numCategories = gameData.length;

  return (
    <PuzzleDataContext.Provider
      value={{ gameData, numCategories, categorySize, isLoading, error, isLocked }}
    >
      {children}
    </PuzzleDataContext.Provider>
  );
}

export default PuzzleDataProvider;
